export default {
  CartaoPcdob: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cartao-pcdob"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CartaoPcdob.js
// module id = 1aOY
// module chunks = 16